import { createApp } from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import ElementPlus from 'element-plus'
import { ElLoading } from 'element-plus'
import 'element-plus/dist/index.css'
import request from '@/utils/request'
import { ElMessage } from 'element-plus'
import { ElMessageBox } from 'element-plus'
import * as Icons from '@element-plus/icons-vue'

import zhCn from 'element-plus/es/locale/lang/zh-cn';

import "@/core/incident.css";

const app = createApp(App)
app.config.globalProperties.$loading = ElLoading
app.config.globalProperties.$req = request
app.config.globalProperties.$Message = ElMessage
app.config.globalProperties.$ElMessageBox = ElMessageBox
app.config.globalProperties.$cookies = Cookies

Object.keys(Icons).forEach(key => {
    app.component(key, Icons[key]);
});

app.use(ElementPlus, { locale: zhCn });
//app.use(ElementPlus)
app.use(store)
app.use(Vuex)
app.use(router)
app.mount('#app')